var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 645,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dot-mask_svg__home-carousel-dot-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint0_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint1_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint2_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint3_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint4_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint5_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint6_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint7_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 4.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint8_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint9_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint10_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint11_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint12_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint13_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 4.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint14_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint15_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint16_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint17_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint18_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint19_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint20_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint21_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint22_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint23_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint24_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint25_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 44.389a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint26_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint27_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint28_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint29_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint30_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint31_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 44.389a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint32_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint33_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint34_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint35_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint36_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint37_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint38_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint39_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint40_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint41_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint42_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint43_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 84.742a4.035 4.035 0 11-4.034-4.035 4.035 4.035 0 014.034 4.035z",
    fill: "url(#dot-mask_svg__paint44_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint45_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint46_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint47_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint48_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint49_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 84.742a4.035 4.035 0 11-4.034-4.035 4.035 4.035 0 014.034 4.035z",
    fill: "url(#dot-mask_svg__paint50_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint51_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint52_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint53_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint54_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint55_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 125.095a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint56_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint57_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 125.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint58_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint59_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint60_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint61_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint62_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint63_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 125.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint64_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint65_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint66_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint67_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint68_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint69_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 125.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint70_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 125.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint71_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 165.448a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint72_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 165.448a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint73_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 165.448a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint74_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint75_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint76_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint77_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint78_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint79_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint80_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint81_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint82_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint83_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint84_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint85_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint86_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint87_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint88_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint89_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint90_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint91_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint92_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint93_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint94_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint95_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint96_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint97_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 205.802a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint98_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint99_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint100_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint101_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint102_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint103_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 205.802a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint104_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint105_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint106_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint107_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint108_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint109_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint110_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint111_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint112_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint113_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint114_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint115_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 246.155a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint116_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint117_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint118_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint119_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint120_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint121_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 246.155a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint122_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint123_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint124_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint125_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint126_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint127_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 286.508a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint128_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint129_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 286.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint130_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint131_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint132_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint133_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint134_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint135_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 286.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint136_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint137_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint138_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint139_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint140_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint141_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 286.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint142_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 286.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint143_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 326.861a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint144_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 326.861a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint145_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 326.861a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint146_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint147_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint148_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint149_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint150_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint151_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint152_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint153_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint154_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint155_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint156_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint157_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint158_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint159_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint160_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint161_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint162_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint163_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint164_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint165_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint166_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint167_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint168_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint169_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 367.215a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint170_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint171_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint172_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint173_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint174_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint175_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 367.215a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint176_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint177_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint178_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint179_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint180_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint181_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint182_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint183_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint184_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint185_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint186_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint187_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 407.568a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint188_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint189_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint190_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint191_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint192_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint193_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 407.568a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint194_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint195_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint196_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint197_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint198_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint199_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 447.921a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint200_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint201_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 447.921a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint202_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint203_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint204_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint205_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint206_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint207_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 447.921a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint208_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint209_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint210_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint211_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint212_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint213_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 447.921a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint214_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 447.921a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint215_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 488.274a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint216_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 488.274a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint217_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 488.274a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint218_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint219_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint220_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint221_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint222_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint223_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint224_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint225_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint226_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint227_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint228_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint229_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint230_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint231_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint232_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint233_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint234_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint235_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint236_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint237_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint238_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint239_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint240_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint241_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 528.628a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint242_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint243_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint244_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint245_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint246_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint247_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 528.628a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint248_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint249_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint250_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint251_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint252_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint253_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint254_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint255_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint256_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint257_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint258_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint259_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 568.981a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint260_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint261_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint262_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint263_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint264_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint265_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 568.981a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint266_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint267_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint268_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint269_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint270_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint271_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 609.334a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint272_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint273_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 609.334a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint274_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint275_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint276_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint277_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint278_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint279_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 609.334a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint280_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint281_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint282_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint283_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint284_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint285_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 609.334a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint286_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 609.334a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint287_angular)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07 609.035a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint288_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 609.035a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint289_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 609.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint290_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint291_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint292_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint293_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint294_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint295_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint296_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint297_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint298_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint299_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint300_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 609.035a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint301_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint302_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint303_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint304_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 609.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint305_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint306_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint307_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint308_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint309_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint310_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint311_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint312_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint313_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 649.389a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint314_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint315_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint316_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint317_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint318_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 649.389a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint319_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 649.389a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint320_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint321_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint322_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 649.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint323_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint324_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint325_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint326_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint327_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint328_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint329_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint330_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint331_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 689.742a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint332_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint333_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint334_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint335_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint336_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 689.742a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint337_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 689.742a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint338_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint339_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint340_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 689.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint341_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint342_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint343_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 730.095a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint344_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 730.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint345_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 730.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint346_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint347_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint348_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint349_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 730.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint350_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 730.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint351_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 730.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint352_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint353_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint354_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 730.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint355_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 730.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint356_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 730.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint357_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 730.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint358_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 730.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint359_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 770.448a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint360_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 770.448a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint361_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 770.448a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint362_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint363_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint364_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint365_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint366_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint367_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint368_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint369_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint370_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint371_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint372_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 770.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint373_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint374_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint375_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint376_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 770.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint377_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint378_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint379_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint380_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint381_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint382_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint383_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint384_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint385_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 810.802a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint386_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint387_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint388_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint389_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint390_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 810.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint391_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 810.802a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint392_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint393_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint394_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 810.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint395_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint396_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint397_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint398_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint399_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint400_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint401_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint402_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint403_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 851.155a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint404_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint405_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint406_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint407_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint408_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 851.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint409_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 851.155a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint410_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint411_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint412_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 851.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint413_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint414_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint415_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 891.508a4.035 4.035 0 11-8.069 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint416_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 891.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint417_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 891.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint418_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint419_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint420_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint421_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 891.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint422_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 891.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint423_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 891.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint424_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint425_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint426_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 891.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint427_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 891.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint428_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 891.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint429_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 891.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint430_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 891.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint431_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 931.861a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint432_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 931.861a4.035 4.035 0 11-8.071.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint433_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 931.861a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint434_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint435_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint436_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint437_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint438_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint439_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint440_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint441_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint442_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint443_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint444_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 931.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint445_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint446_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint447_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint448_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 931.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint449_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint450_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint451_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint452_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint453_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint454_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint455_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint456_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint457_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 972.215a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint458_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint459_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint460_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint461_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint462_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 972.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint463_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 972.215a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint464_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint465_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint466_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 972.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint467_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1012.57a4.03 4.03 0 01-4.035 4.03A4.03 4.03 0 010 1012.57c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint468_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint469_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1012.57a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint470_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint471_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint472_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint473_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint474_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint475_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1012.57a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint476_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint477_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint478_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint479_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint480_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint481_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1012.57a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint482_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint483_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint484_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1012.57a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint485_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1052.92c0 2.23-1.807 4.04-4.035 4.04A4.038 4.038 0 010 1052.92a4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint486_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint487_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1052.92c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint488_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint489_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint490_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint491_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint492_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint493_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1052.92c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint494_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint495_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint496_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint497_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint498_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1052.92c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint499_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1052.92c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint500_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint501_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint502_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1052.92c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint503_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint504_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint505_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1093.27c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint506_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint507_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint508_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint509_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint510_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint511_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1093.27c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint512_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint513_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint514_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint515_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint516_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1093.27c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint517_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1093.27c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint518_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint519_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint520_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1093.27c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint521_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1133.63a4.03 4.03 0 01-4.035 4.03A4.03 4.03 0 010 1133.63c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint522_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint523_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1133.63a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint524_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint525_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint526_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint527_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint528_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint529_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1133.63a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint530_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint531_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint532_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint533_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint534_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.039 4.039 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint535_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1133.63a4.03 4.03 0 01-4.034 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.806-4.04 4.035-4.04a4.038 4.038 0 014.034 4.04z",
    fill: "url(#dot-mask_svg__paint536_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.034-4.03c0-2.23 1.806-4.04 4.034-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint537_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint538_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1133.63a4.03 4.03 0 01-4.035 4.03 4.03 4.03 0 01-4.035-4.03c0-2.23 1.807-4.04 4.035-4.04a4.038 4.038 0 014.035 4.04z",
    fill: "url(#dot-mask_svg__paint539_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1173.98c0 2.23-1.807 4.04-4.035 4.04A4.038 4.038 0 010 1173.98a4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint540_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint541_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1173.98c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint542_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint543_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint544_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint545_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint546_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint547_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1173.98c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint548_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint549_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint550_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint551_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint552_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1173.98c0 2.23-1.807 4.04-4.035 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint553_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1173.98c0 2.23-1.806 4.04-4.034 4.04a4.038 4.038 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint554_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.038 4.038 0 01-4.034-4.04 4.03 4.03 0 014.034-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint555_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint556_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1173.98c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.03 4.03 0 014.035-4.03 4.03 4.03 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint557_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint558_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.419 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint559_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 1214.33c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint560_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint561_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.465 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint562_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint563_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.163 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint564_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.512 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint565_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86 1214.33c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint566_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint567_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.558 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint568_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.907 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint569_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.256 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04c0-2.22 1.807-4.03 4.035-4.03a4.036 4.036 0 014.035 4.03z",
    fill: "url(#dot-mask_svg__paint570_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.605 1214.33c0 2.23-1.807 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint571_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.953 1214.33c0 2.23-1.806 4.04-4.034 4.04a4.036 4.036 0 010-8.07 4.036 4.036 0 014.034 4.03z",
    fill: "url(#dot-mask_svg__paint572_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.302 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.036 4.036 0 114.035-4.04z",
    fill: "url(#dot-mask_svg__paint573_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.651 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint574_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1214.33c0 2.23-1.806 4.04-4.035 4.04a4.039 4.039 0 01-4.035-4.04 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint575_angular)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.07 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint576_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint577_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 4.035a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint578_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint579_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 4.035a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint580_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint581_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint582_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 4.035a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint583_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 4.035a4.036 4.036 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011012.83 0c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint584_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 4.035a4.038 4.038 0 01-4.04 4.036 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint585_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 4.035a4.038 4.038 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036A4.03 4.03 0 011093.52 0c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint586_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 4.035a4.038 4.038 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036A4.03 4.03 0 011133.87 0c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint587_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 4.035a4.038 4.038 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036A4.03 4.03 0 011174.22 0c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint588_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 4.035a4.03 4.03 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011214.57 0a4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint589_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 4.035a4.03 4.03 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011254.92 0a4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint590_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 4.035a4.03 4.03 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011295.27 0a4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint591_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 4.035a4.036 4.036 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011335.62 0c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint592_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 4.035a4.036 4.036 0 01-4.03 4.036 4.038 4.038 0 01-4.04-4.036A4.038 4.038 0 011375.97 0c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint593_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint594_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint595_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 44.389a4.035 4.035 0 11-8.07.001 4.035 4.035 0 018.07-.001z",
    fill: "url(#dot-mask_svg__paint596_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint597_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint598_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint599_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint600_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 44.389a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint601_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 44.389a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint602_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 44.389a4.038 4.038 0 01-4.04 4.035 4.036 4.036 0 010-8.07c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint603_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 44.389a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint604_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 44.389a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint605_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 44.389a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint606_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 44.389a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint607_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 44.389a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint608_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 44.389a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint609_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 44.389a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint610_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 44.389a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint611_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint612_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint613_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 84.742a4.035 4.035 0 11-4.034-4.035 4.035 4.035 0 014.034 4.035z",
    fill: "url(#dot-mask_svg__paint614_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint615_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint616_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint617_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint618_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 84.742a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint619_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 84.742a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035c2.22 0 4.03 1.806 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint620_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 84.742a4.038 4.038 0 01-4.04 4.035 4.036 4.036 0 010-8.07c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint621_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 84.742a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint622_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 84.742a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint623_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 84.742a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint624_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 84.742a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint625_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 84.742a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint626_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 84.742a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint627_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 84.742a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035c2.22 0 4.03 1.806 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint628_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 84.742a4.036 4.036 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035c2.22 0 4.03 1.806 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint629_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint630_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint631_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint632_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 125.095a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint633_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 125.095a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint634_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint635_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint636_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 125.095a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint637_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 125.095a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint638_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 125.095a4.036 4.036 0 11-4.04-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint639_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 125.095a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint640_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 125.095a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint641_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 125.095a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint642_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 125.095a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint643_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 125.095a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint644_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 125.095a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint645_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 125.095a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint646_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 125.095a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint647_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint648_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint649_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint650_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint651_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 165.448a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint652_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint653_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint654_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 165.448a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint655_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 165.448a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint656_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 165.448a4.039 4.039 0 01-4.04 4.036 4.037 4.037 0 010-8.071c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint657_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 165.448a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint658_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 165.448a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint659_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 165.448a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint660_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 165.448a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint661_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 165.448a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint662_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 165.448a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint663_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 165.448a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint664_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 165.448a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint665_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint666_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint667_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 205.802a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint668_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint669_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 205.802a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint670_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint671_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint672_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 205.802a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint673_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 205.802a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint674_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 205.802a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint675_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 205.802a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint676_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 205.802a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint677_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 205.802a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint678_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 205.802a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint679_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 205.802a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint680_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 205.802a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint681_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 205.802a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint682_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 205.802a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint683_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint684_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint685_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 246.155a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint686_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint687_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 246.155a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint688_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint689_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint690_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 246.155a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint691_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 246.155a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint692_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 246.155a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint693_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 246.155a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint694_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 246.155a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint695_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 246.155a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint696_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 246.155a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint697_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 246.155a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint698_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 246.155a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint699_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 246.155a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint700_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 246.155a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint701_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint702_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint703_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint704_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 286.508a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint705_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 286.508a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint706_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint707_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint708_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 286.508a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint709_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 286.508a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint710_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 286.508a4.036 4.036 0 11-4.04-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint711_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 286.508a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint712_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 286.508a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint713_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 286.508a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint714_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 286.508a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint715_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 286.508a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint716_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 286.508a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint717_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 286.508a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint718_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 286.508a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint719_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint720_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint721_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint722_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint723_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 326.861a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint724_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint725_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint726_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 326.861a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint727_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 326.861a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint728_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 326.861a4.039 4.039 0 01-4.04 4.036 4.037 4.037 0 010-8.071c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint729_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 326.861a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint730_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 326.861a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint731_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 326.861a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint732_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 326.861a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint733_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 326.861a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint734_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 326.861a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint735_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 326.861a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint736_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 326.861a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint737_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint738_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint739_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 367.215a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint740_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint741_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 367.215a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint742_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint743_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint744_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 367.215a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint745_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 367.215a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint746_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 367.215a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint747_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 367.215a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint748_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 367.215a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint749_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 367.215a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint750_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 367.215a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint751_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 367.215a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint752_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 367.215a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint753_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 367.215a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint754_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 367.215a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint755_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint756_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint757_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 407.568a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint758_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint759_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 407.568a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint760_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint761_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint762_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 407.568a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint763_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 407.568a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint764_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 407.568a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint765_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 407.568a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint766_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 407.568a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint767_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 407.568a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint768_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 407.568a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint769_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 407.568a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint770_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 407.568a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint771_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 407.568a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint772_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 407.568a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint773_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint774_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint775_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint776_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 447.921a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint777_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 447.921a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint778_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint779_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint780_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 447.921a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint781_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 447.921a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint782_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 447.921a4.036 4.036 0 11-4.04-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint783_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 447.921a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint784_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 447.921a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint785_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 447.921a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint786_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 447.921a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint787_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 447.921a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint788_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 447.921a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint789_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 447.921a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint790_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 447.921a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint791_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint792_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint793_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint794_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint795_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 488.274a4.035 4.035 0 11-8.07.002 4.035 4.035 0 018.07-.002z",
    fill: "url(#dot-mask_svg__paint796_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint797_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint798_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 488.274a4.036 4.036 0 11-8.072 0 4.036 4.036 0 018.072 0z",
    fill: "url(#dot-mask_svg__paint799_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 488.274a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint800_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 488.274a4.039 4.039 0 01-4.04 4.036 4.037 4.037 0 010-8.071c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint801_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 488.274a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint802_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 488.274a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint803_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 488.274a4.039 4.039 0 01-4.04 4.036 4.03 4.03 0 01-4.03-4.036 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.807 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint804_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 488.274a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint805_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 488.274a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint806_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 488.274a4.03 4.03 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint807_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 488.274a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint808_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 488.274a4.037 4.037 0 01-4.03 4.036 4.039 4.039 0 01-4.04-4.036 4.039 4.039 0 014.04-4.035c2.22 0 4.03 1.807 4.03 4.035z",
    fill: "url(#dot-mask_svg__paint809_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint810_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint811_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 528.628a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint812_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint813_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 528.628a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint814_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint815_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint816_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 528.628a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint817_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 528.628a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint818_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 528.628a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint819_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 528.628a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint820_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 528.628a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint821_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 528.628a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint822_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 528.628a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint823_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 528.628a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint824_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 528.628a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint825_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 528.628a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint826_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 528.628a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint827_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint828_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint829_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 568.981a4.035 4.035 0 11-4.034-4.036 4.035 4.035 0 014.034 4.036z",
    fill: "url(#dot-mask_svg__paint830_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint831_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 568.981a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint832_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint833_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint834_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 568.981a4.036 4.036 0 11-8.071-.001 4.036 4.036 0 018.071.001z",
    fill: "url(#dot-mask_svg__paint835_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 568.981a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint836_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 568.981a4.039 4.039 0 01-4.04 4.035 4.036 4.036 0 010-8.071c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint837_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 568.981a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint838_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 568.981a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint839_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 568.981a4.039 4.039 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.036c2.23 0 4.04 1.807 4.04 4.036z",
    fill: "url(#dot-mask_svg__paint840_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 568.981a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint841_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 568.981a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint842_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 568.981a4.03 4.03 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036 4.03 4.03 0 014.03 4.036z",
    fill: "url(#dot-mask_svg__paint843_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 568.981a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint844_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 568.981a4.036 4.036 0 01-4.03 4.035 4.039 4.039 0 01-4.04-4.035 4.039 4.039 0 014.04-4.036c2.22 0 4.03 1.807 4.03 4.036z",
    fill: "url(#dot-mask_svg__paint845_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.07 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint846_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.419 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint847_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.767 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint848_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.116 609.334a4.034 4.034 0 11-8.069 0 4.034 4.034 0 118.069 0z",
    fill: "url(#dot-mask_svg__paint849_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.465 609.334a4.034 4.034 0 11-8.07 0 4.035 4.035 0 118.07 0z",
    fill: "url(#dot-mask_svg__paint850_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.814 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint851_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.163 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint852_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.512 609.334a4.035 4.035 0 11-8.07 0 4.035 4.035 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint853_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 609.334a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint854_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.21 609.334a4.036 4.036 0 11-4.04-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint855_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.56 609.334a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint856_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.91 609.334a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint857_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.26 609.334a4.038 4.038 0 01-4.04 4.035 4.03 4.03 0 01-4.03-4.035 4.03 4.03 0 014.03-4.035c2.23 0 4.04 1.806 4.04 4.035z",
    fill: "url(#dot-mask_svg__paint858_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.6 609.334a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint859_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.95 609.334a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint860_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.3 609.334a4.03 4.03 0 01-4.03 4.035 4.038 4.038 0 01-4.04-4.035 4.038 4.038 0 014.04-4.035 4.03 4.03 0 014.03 4.035z",
    fill: "url(#dot-mask_svg__paint861_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.65 609.334a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint862_angular)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 609.334a4.036 4.036 0 01-8.07 0 4.036 4.036 0 018.07 0z",
    fill: "url(#dot-mask_svg__paint863_angular)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint0_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint1_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint2_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint3_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint4_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint5_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint6_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint7_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint8_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint9_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint10_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint11_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint12_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint13_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint14_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint15_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint16_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint17_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint18_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint19_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint20_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint21_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint22_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint23_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint24_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint25_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint26_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint27_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint28_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint29_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint30_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint31_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint32_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint33_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint34_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint35_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint36_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint37_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint38_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint39_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint40_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint41_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint42_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint43_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint44_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint45_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint46_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint47_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint48_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint49_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint50_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint51_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint52_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint53_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint54_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint55_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint56_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint57_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint58_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint59_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint60_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint61_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint62_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint63_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint64_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint65_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint66_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint67_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint68_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint69_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint70_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint71_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint72_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint73_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint74_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint75_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint76_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint77_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint78_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint79_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint80_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint81_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint82_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint83_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint84_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint85_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint86_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint87_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint88_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint89_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint90_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint91_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint92_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint93_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint94_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint95_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint96_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint97_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint98_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint99_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint100_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint101_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint102_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint103_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint104_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint105_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint106_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint107_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint108_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint109_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint110_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint111_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint112_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint113_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint114_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint115_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint116_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint117_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint118_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint119_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint120_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint121_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint122_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint123_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint124_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint125_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint126_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint127_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint128_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint129_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint130_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint131_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint132_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint133_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint134_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint135_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint136_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint137_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint138_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint139_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint140_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint141_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint142_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint143_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint144_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint145_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint146_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint147_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint148_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint149_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint150_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint151_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint152_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint153_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint154_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint155_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint156_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint157_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint158_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint159_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint160_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint161_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint162_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint163_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint164_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint165_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint166_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint167_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint168_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint169_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint170_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint171_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint172_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint173_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint174_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint175_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint176_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint177_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint178_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint179_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint180_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint181_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint182_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint183_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint184_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint185_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint186_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint187_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint188_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint189_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint190_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint191_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint192_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint193_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint194_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint195_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint196_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint197_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint198_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint199_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint200_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint201_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint202_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint203_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint204_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint205_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint206_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint207_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint208_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint209_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint210_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint211_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint212_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint213_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint214_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint215_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint216_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint217_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint218_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint219_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint220_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint221_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint222_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint223_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint224_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint225_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint226_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint227_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint228_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint229_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint230_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint231_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint232_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint233_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint234_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint235_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint236_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint237_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint238_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint239_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint240_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint241_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint242_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint243_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint244_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint245_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint246_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint247_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint248_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint249_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint250_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint251_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint252_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint253_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint254_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint255_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint256_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint257_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint258_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint259_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint260_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint261_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint262_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint263_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint264_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint265_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint266_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint267_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint268_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint269_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint270_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint271_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint272_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint273_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint274_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint275_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint276_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint277_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint278_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint279_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint280_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint281_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint282_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint283_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint284_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint285_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint286_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint287_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint288_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint289_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint290_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint291_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint292_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint293_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint294_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint295_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint296_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint297_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint298_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint299_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint300_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint301_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint302_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint303_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint304_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint305_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint306_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint307_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint308_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint309_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint310_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint311_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint312_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint313_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint314_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint315_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint316_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint317_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint318_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint319_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint320_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint321_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint322_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint323_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint324_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint325_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint326_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint327_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint328_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint329_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint330_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint331_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint332_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint333_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint334_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint335_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint336_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint337_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint338_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint339_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint340_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint341_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint342_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint343_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint344_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint345_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint346_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint347_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint348_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint349_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint350_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint351_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint352_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint353_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint354_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint355_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint356_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint357_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint358_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint359_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint360_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint361_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint362_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint363_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint364_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint365_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint366_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint367_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint368_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint369_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint370_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint371_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint372_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint373_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint374_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint375_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint376_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint377_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint378_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint379_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint380_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint381_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint382_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint383_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint384_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint385_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint386_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint387_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint388_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint389_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint390_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint391_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint392_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint393_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint394_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint395_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint396_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint397_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint398_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint399_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint400_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint401_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint402_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint403_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint404_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint405_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint406_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint407_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint408_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint409_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint410_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint411_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint412_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint413_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint414_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint415_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint416_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint417_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint418_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint419_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint420_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint421_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint422_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint423_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint424_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint425_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint426_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint427_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint428_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint429_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint430_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint431_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint432_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint433_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint434_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint435_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint436_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint437_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint438_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint439_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint440_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint441_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint442_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint443_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint444_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint445_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint446_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint447_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint448_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint449_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint450_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint451_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint452_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint453_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint454_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint455_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint456_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint457_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint458_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint459_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint460_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint461_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint462_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint463_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint464_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint465_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint466_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint467_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint468_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint469_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint470_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint471_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint472_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint473_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint474_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint475_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint476_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint477_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint478_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint479_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint480_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint481_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint482_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint483_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint484_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint485_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint486_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint487_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint488_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint489_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint490_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint491_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint492_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint493_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint494_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint495_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint496_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint497_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint498_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint499_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint500_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint501_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint502_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint503_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint504_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint505_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint506_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint507_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint508_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint509_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint510_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint511_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint512_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint513_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint514_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint515_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint516_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint517_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint518_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint519_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint520_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint521_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint522_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint523_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint524_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint525_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint526_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint527_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint528_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint529_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint530_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint531_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint532_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint533_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint534_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint535_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint536_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint537_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint538_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint539_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint540_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint541_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint542_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint543_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint544_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint545_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint546_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint547_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint548_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint549_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint550_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint551_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint552_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint553_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint554_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint555_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint556_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint557_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint558_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint559_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint560_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint561_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint562_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint563_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint564_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint565_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint566_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint567_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint568_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint569_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint570_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint571_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint572_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint573_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint574_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint575_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 347 911.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint576_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint577_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint578_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint579_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint580_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint581_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint582_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint583_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint584_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint585_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint586_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint587_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint588_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint589_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint590_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint591_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint592_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint593_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint594_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint595_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint596_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint597_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint598_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint599_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint600_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint601_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint602_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint603_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint604_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint605_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint606_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint607_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint608_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint609_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint610_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint611_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint612_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint613_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint614_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint615_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint616_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint617_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint618_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint619_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint620_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint621_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint622_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint623_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint624_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint625_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint626_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint627_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint628_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint629_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint630_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint631_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint632_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint633_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint634_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint635_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint636_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint637_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint638_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint639_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint640_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint641_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint642_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint643_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint644_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint645_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint646_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint647_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint648_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint649_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint650_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint651_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint652_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint653_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint654_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint655_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint656_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint657_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint658_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint659_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint660_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint661_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint662_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint663_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint664_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint665_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint666_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint667_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint668_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint669_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint670_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint671_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint672_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint673_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint674_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint675_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint676_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint677_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint678_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint679_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint680_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint681_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint682_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint683_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint684_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint685_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint686_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint687_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint688_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint689_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint690_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint691_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint692_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint693_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint694_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint695_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint696_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint697_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint698_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint699_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint700_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint701_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint702_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint703_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint704_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint705_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint706_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint707_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint708_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint709_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint710_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint711_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint712_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint713_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint714_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint715_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint716_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint717_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint718_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint719_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint720_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint721_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint722_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint723_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint724_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint725_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint726_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint727_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint728_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint729_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint730_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint731_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint732_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint733_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint734_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint735_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint736_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint737_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint738_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint739_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint740_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint741_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint742_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint743_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint744_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint745_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint746_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint747_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint748_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint749_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint750_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint751_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint752_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint753_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint754_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint755_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint756_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint757_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint758_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint759_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint760_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint761_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint762_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint763_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint764_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint765_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint766_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint767_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint768_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint769_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint770_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint771_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint772_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint773_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint774_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint775_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint776_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint777_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint778_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint779_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint780_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint781_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint782_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint783_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint784_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint785_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint786_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint787_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint788_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint789_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint790_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint791_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint792_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint793_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint794_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint795_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint796_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint797_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint798_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint799_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint800_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint801_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint802_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint803_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint804_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint805_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint806_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint807_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint808_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint809_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint810_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint811_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint812_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint813_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint814_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint815_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint816_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint817_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint818_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint819_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint820_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint821_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint822_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint823_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint824_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint825_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint826_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint827_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint828_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint829_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint830_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint831_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint832_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint833_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint834_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint835_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint836_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint837_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint838_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint839_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint840_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint841_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint842_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint843_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint844_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint845_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint846_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint847_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint848_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint849_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint850_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint851_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint852_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint853_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint854_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint855_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint856_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint857_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint858_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint859_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint860_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint861_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint862_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dot-mask_svg__paint863_angular",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(405.10285 263.103 -266.30625 410.03492 1033 306.685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#6AE63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E63EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#35D2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F435E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dot-mask_svg__home-carousel-dot-mask"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h726v645H0z"
  })))));
}
export default __webpack_public_path__ + "static/dot-mask.81020472.svg";
export { SvgDotMask as ReactComponent };